import { React, useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../../../contexts/authContext';
import { useNavigate } from 'react-router-dom';

import { useForm } from '@mantine/form';
import { PasswordInput, Modal, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronLeft } from '@tabler/icons-react';

import AppHdWithReturnLeft from '../../../../composents/Headers/AppHeaders/AppHdWithReturnLeft/AppHdWithReturnLeft';
import SyndicRectangleButton from '../../../../composents/Buttons/Syndic/RectangleButton/RectangleButtonMain';
import RectangleButtonDisabled from '../../../../composents/Buttons/All/RectangleButtonDisabled/RectangleButtonDisabled';
import AppDesktopLogo from '../../../../composents/Logo/AppDesktopLogo/AppDesktopLogo';

function ChangePsw () {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const [opened, { open, close }] = useDisclosure(false);
    const [error, setError] = useState()

    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        };
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);


    const form = useForm({
        initialValues: {
            password:"",
            newPassword:"",
            newPasswordConfirmation:""
        },

        validate: {
            password: (value) => (
                value.length < 1
                  ? 'Renseignez votre mot de passe.'
                  : null
              ),
            newPassword: (value) => (
                value && /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/.test(value)
                    ? null
                    : 'Le mot de passe doit comporter au moins 8 caractères avec une majuscule, une minuscule et un caractère spécial.'
                ),
            newPasswordConfirmation: (value, values) => (
                value.length < 1
                    ? 'Le mot de passe doit être identique.'
                    :  value !== values.newPassword
                    ? 'Le mot de passe doit être identique.'
                    : null
            )     
        }
    })

    const handleFormSubmit = async (values, _event) => {
        _event.preventDefault();
        try {
            const token = localStorage.getItem('token');
            const response = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/app/profile/param/psw-edit", {
                method: "POST",
                body: JSON.stringify({
                    password: values.password,
                    newPassword: values.newPassword
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            if(response.ok) {
                open();
                setTimeout(() => {
                    navigate("/app/profile/menu");
                }, 700)
            } else {
                const errorResponse = await response.json();
                if (errorResponse.error === "Mot de passe erroné.") {
                    setError("Mot de passe erroné.");
                }
            }
        } catch (error) {
    }
}

    return(
        <>
            {isMobile ? (
                <>
                    <form onSubmit={form.onSubmit(handleFormSubmit)}>
                    
                        <AppHdWithReturnLeft>Modifier mon mot de passe</AppHdWithReturnLeft>

                        <div className="width90pCenter" sx={{ maxWidth: 300 }} mx="auto">
                            <PasswordInput
                                label="Mot de passe"
                                placeholder="********"
                                {...form.getInputProps('password')}
                            />
                            {error && <p className='txt13 rT mrgT5'>{error}</p>}

                            <div className="mrgB5"></div>

                            <PasswordInput
                                label="Nouveau mot de passe"
                                placeholder="********"
                                {...form.getInputProps('newPassword')}
                            />

                            <div className="mrgB5"></div>

                            <PasswordInput
                                label="Confirmation du nouveau mot de passe"
                                placeholder="********"
                                {...form.getInputProps('newPasswordConfirmation')}
                            />
                        </div>

                        <div className="mrgB20"></div>

                        <div className="width90pCenter">
                            {form.isDirty() 
                                ?   <SyndicRectangleButton type="submit">
                                        <p id="syndicChangesPswga4" className='noMrgTB'>Enregistrer</p>
                                    </SyndicRectangleButton>
                                :   <RectangleButtonDisabled>
                                        Enregistrer
                                    </RectangleButtonDisabled>
                            }
                    
                            
                            {open
                                ?   <Modal
                                        centered
                                        size="auto"
                                        opened={opened}
                                        onClose={close}
                                        withCloseButton={false}>
                                        <p className=" txtCenter noMrgTB txt15">
                                            Nouveau mot de passe enregistré
                                        </p>
                                    </Modal> 
                                :   ""
                            }
                        </div>
                    </form>
                </>
            ) : (
                <>
                    <AppDesktopLogo/>
                    <form onSubmit={form.onSubmit(handleFormSubmit)}>
                        <div className="offer-desktop-page-bg" style={{ padding: "0 0 60px", alignItems: "flex-start", flexDirection: "column" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", margin: "40px auto 20px", width: "39%" }}>
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                style={{
                                    height: 36,
                                    width: 110,
                                    opacity: 0.9,
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: 50,
                                    border: "none",
                                    padding: "0 12px",
                                    boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                                    cursor: "pointer",
                                    justifySelf: "start",
                                }}
                            >
                                <div className="horizontal iCenter">
                                    <IconChevronLeft width={20} />
                                    <p className="txt18 medium noMrgTB mrgL5">Retour</p>
                                </div>
                            </button>
                            <h2 className="noMrgTB" style={{ gridColumn: 2, justifySelf: "center" }}>Modifier mon mot de passe</h2>
                            <div />
                        </div>
                        <div className="offer-form-card" style={{ width: "39%" }}>
                            <div>
                            <PasswordInput
                                label="Mot de passe"
                                placeholder="********"
                                size='md'
                                {...form.getInputProps('password')}                                
                            />
                            {error && <p className='txt13 rT mrgT5'>{error}</p>}

                            <div className="mrgB10"></div>

                            <PasswordInput
                                label="Nouveau mot de passe"
                                placeholder="********"
                                size='md'
                                {...form.getInputProps('newPassword')}
                            />

                            <div className="mrgB10"></div>

                            <PasswordInput
                                label="Confirmation du nouveau mot de passe"
                                placeholder="********"
                                size='md'
                                {...form.getInputProps('newPasswordConfirmation')}
                            />

                        <div className="mrgB30"></div>

                        <div className="txtCenter">
                            {form.isDirty()
                                ?   <Button type="submit" color="dark" radius="xl" size="md" w={200} styles={{ label: { fontSize: 16, fontWeight: 500 } }}>
                                        Enregistrer
                                    </Button>
                                :   <Button disabled color="gray" radius="xl" size="md" w={200} styles={{ label: { fontSize: 16, fontWeight: 500 } }}>
                                        Enregistrer
                                    </Button>
                            }


                            {open
                                ?   <Modal
                                        centered
                                        size="auto"
                                        opened={opened}
                                        onClose={close}
                                        withCloseButton={false}>
                                        <p className=" txtCenter noMrgTB txt16">
                                            Nouveau mot de passe enregistré
                                        </p>
                                    </Modal>
                                :   ""
                            }
                            </div>
                            </div>
                        </div>
                        </div>
                    </form>
                </>
            )}
        </>
    )
}

export default ChangePsw;



